// importing and setting up Font Awesome
import { dom, library } from "@fortawesome/fontawesome-svg-core";

/*
    fab: fa-brands
    fas: fa-solid
    far: fa-regular
    fal: fa-light
    fat: fa-thin
    fad: fa-duotone
    fass: sharp-solid
    fasr: sharp-regular
    fasl: sharp-light
*/

import {
	fa1 as far1,
	fa2 as far2,
	fa3 as far3,
	fa4 as far4,
	faArrowsMaximize as farArrowsMaximize,
	faBadgeCheck as farBadgeCheck,
	faBars as farBars,
	faBicycle as farBicycle,
	faBlockQuestion as farBlockQuestion,
	faBuilding as farBuilding,
	faCalendar as farCalendar,
	faChartLineUp as farChartLineUp,
	faChevronDown as farChevronDown,
	faChevronLeft as farChevronLeft,
	faChevronRight as farChevronRight,
	faChevronUp as farChevronUp,
	faCircleExclamation as farCircleExclamation,
	faCircleInfo as farCircleInfo,
	faCity as farCity,
	faEnvelope as farEnvelope,
	faEnvelopes as farEnvelopes,
	faFileCsv as farFileCsv,
	faFileDoc as farFileDoc,
	faFileExcel as farFileExcel,
	faFilePdf as farFilePdf,
	faFiles as farFiles,
	faFileWord as farFileWord,
	faFileZip as farFileZip,
	faGlobe as farGlobe,
	faHandHoldingHeart as farHandHoldingHeart,
	faHandshake as farHandshake,
	faHeart as farHeart,
	faKeySkeleton as farKeySkeleton,
	faLandmark as farLandmark,
	faLaptop as farLaptop,
	faListCheck as farListCheck,
	faListOl as farListOl,
	faLocationDot as farLocationDot,
	faLock as farLock,
	faPersonChalkboard as farPersonChalkboard,
	faPhone as farPhone,
	faPlane as farPlane,
	faPlus as farPlus,
	faRobot as farRobot,
	faRocketLaunch as farRocketLaunch,
	faSackDollar as farSackDollar,
	faShieldHalved as farShieldHalved,
	faServer as farServer,
	faSnowflake as farSnowflake,
	faSquare as farSquare,
	faStar as farStar,
	faTemperatureLow as farTemperatureLow,
	faTimes as farTimes,
	faVectorSquare as farVectorSquare,
	faVideo as farVideo,
	faXmark as farXMark,
} from "@fortawesome/pro-regular-svg-icons";

import {
	faAddressCard as fasAddressCard,
	faArrowDown as fasArrowDown,
	faArrowDownToLine as fasArrowDownToLine,
	faArrowLeft as fasArrowLeft,
	faArrowProgress as fasArrowProgress,
	faArrowRight as fasArrowRight,
	faArrowRightLong as fasArrowRightLong,
	faArrowsLeftRightToLine as fasArrowsLeftRightToLine,
	faArrowsMaximize as fasArrowsMaximize,
	faArrowTrendUp as fasArrowTrendUp,
	faArrowUpBigSmall as fasArrowUpBigSmall,
	faArrowUpRightDots as fasArrowUpRightDots,
	faArrowUpRightFromSquare as fasArrowUpRightFromSquare,
	faBadgeCheck as fasBadgeCheck,
	faBicycle as fasBicycle,
	faBillboard as fasBillboard,
	faBlock as fasBlock,
	faBlockBrick as fasBlockBrick,
	faBlog as fasBlog,
	faBolt as fasBolt,
	faBookOpen as fasBookOpen,
	faBoxesStacked as fasBoxesStacked,
	faBrush as fasBrush,
	faBuilding as fasBuilding,
	faBuildings as fasBuildings,
	faBuildingShield as fasBuildingShield,
	faBullhorn as fasBullhorn,
	faBullseye as fasBullseye,
	faBullseyeArrow as fasBullseyeArrow,
	faBullseyePointer as fasBullseyePointer,
	faCalculatorSimple as fasCalculatorSimple,
	faCalendar as fasCalendar,
	faCalendarCheck as fasCalendarCheck,
	faCalendarDay as fasCalendarDay,
	faCalendarDays as fasCalendarDays,
	faCalendarPlus as fasCalendarPlus,
	faCameraCctv as fasCameraCctv,
	faCar as fasCar,
	faCaretDown as fasCaretDown,
	faCaretLeft as fasCaretLeft,
	faCaretRight as fasCaretRight,
	faCaretUp as fasCaretUp,
	faCarSideBolt as fasCarSideBolt,
	faCartFlatbedBoxes as fasCartFlatbedBoxes,
	faChairOffice as fasChairOffice,
	faChargingStation as fasChargingStation,
	faChartMixed as fasChartMixed,
	faChartScatter as fasChartScatter,
	faChartSimple as fasChartSimple,
	faChartSimpleHorizontal as fasChartSimpleHorizontal,
	faCheck as fasCheck,
	faChess as fasChess,
	faChessKingPiece as fasChessKingPiece,
	faChevronDown as fasChevronDown,
	faChevronLeft as fasChevronLeft,
	faChevronRight as fasChevronRight,
	faChevronUp as fasChevronUp,
	faCircleArrowUp as fasCircleArrowUp,
	faCircleBolt as fasCircleBolt,
	faCircleCheck as fasCircleCheck,
	faCircleInfo as fasCircleInfo,
	faCircleNodes as fasCircleNodes,
	faCircleParking as fasCircleParking,
	faCircleQuestion as fasCircleQuestion,
	faCircleUser as fasCircleUser,
	faCity as fasCity,
	faCoin as fasCoin,
	faCoins as fasCoins,
	faCompass as fasCompass,
	faCompassDrafting as fasCompassDrafting,
	faContainerStorage as fasContainerStorage,
	faConveyorBelt as fasConveyorBelt,
	faConveyorBeltArm as fasConveyorBeltArm,
	faConveyorBeltBoxes as fasConveyorBeltBoxes,
	faCrosshairs as fasCrosshairs,
	faCrosshairsSimple as fasCrosshairsSimple,
	faCube as fasCube,
	faCubes as fasCubes,
	faDisplayChartUp as fasDisplayChartUp,
	faDownload as fasDownload,
	faEarthEurope as fasEarthEurope,
	faEnvelope as fasEnvelope,
	faEnvelope as fasEnvelopes,
	faEnvelopesBulk as fasEnvelopesBulk,
	faExpand as fasExpand,
	faExpandWide as fasExpandWide,
	faExternalLink as fasExternalLink,
	faFaceSmile as fasFaceSmile,
	faFileAlt as fasFileAlt,
	faFileCertificate as fasFileCertificate,
	faFileContract as fasFileContract,
	faFileCsv as fasFileCsv,
	faFileExcel as fasFileExcel,
	faFileImage as fasFileImage,
	faFileLines as fasFileLines,
	faFileLock as fasFileLock,
	faFilePdf as fasFilePdf,
	faFilePowerpoint as fasFilePowerpoint,
	faFiles as fasFiles,
	faFileShield as fasFileShield,
	faFileSignature as fasFileSignature,
	faFileVideo as fasFileVideo,
	faFileWord as fasFileWord,
	faFileZip as fasFileZip,
	faFolders as fasFolders,
	faForklift as fasForklift,
	faForward as fasForward,
	faForwardFast as fasForwardFast,
	faFrame as fasFrame,
	faGasPump as fasGasPump,
	faGears as fasGears,
	faGlobeStand as fasGlobeStand,
	faHandHoldingBox as fasHandHoldingBox,
	faHandHoldingHeart as fasHandHoldingHeart,
	faHandHoldingSeedling as fasHandHoldingSeedling,
	faHandshake as fasHandshake,
	faHashtag as fasHashtag,
	faHeart as fasHeart,
	faHeartPulse as fasHeartPulse,
	faHelmetSafety as fasHelmetSafety,
	faHome as fasHome,
	faHouse as fasHouse,
	faIndustry as fasIndustry,
	faIndustryWindows as fasIndustryWindows,
	faLandmark as fasLandmark,
	faLandmarkFlag as fasLandmarkFlag,
	faLanguage as fasLanguage,
	faLayerGroup as fasLayerGroup,
	faLeaf as fasLeaf,
	faLeafHeart as fasLeafHeart,
	faLeafOak as fasLeafOak,
	faLeafyGreen as fasLeafyGreen,
	faLightbulbOn as fasLightbulbOn,
	faLinesLeaning as fasLinesLeaning,
	faList as fasList,
	faListCheck as fasListCheck,
	faLocationCheck as fasLocationCheck,
	faLocationDot as fasLocationDot,
	faMagnifyingGlass as fasMagnifingGlass,
	faMap as fasMap,
	faMaximize as fasMaximize,
	faMemo as fasMemo,
	faMemoPad as fasMemoPad,
	faMeterBolt as fasMeterBolt,
	faMicroscope as fasMicroscope,
	faMinus as fasMinus,
	faMoneyBill as fasMoneyBill,
	faMoneyBillTransfer as fasMoneyBillTransfer,
	faMoneyBillTrendUp as fasMoneyBillTrendUp,
	faMoneyBillWave as fasMoneyBillWave,
	faMonitorWaveform as fasMonitorWaveform,
	faNewspaper as fasNewspaper,
	faPalette as fasPalette,
	faPalletBox as fasPalletBox,
	faPalletBoxes as fasPalletBoxes,
	faPaperclip as fasPaperclip,
	faPartyHorn as fasPartyHorn,
	faPenRuler as fasPenRuler,
	faPeopleArrows as fasPeopleArrows,
	faPeopleGroup as fasPeopleGroup,
	faPeopleLine as fasPeopleLine,
	faPeopleRoof as fasPeopleRoof,
	faPersonCarryBox as fasPersonCarryBox,
	faPersonDigging as fasPersonDigging,
	faPersonDolly as fasPersonDolly,
	faPersonDollyEmpty as fasPersonDollyEmpty,
	faPersonRays as fasPersonRays,
	faPersonShelter as fasPersonShelter,
	faPhone as fasPhone,
	faPlane as fasPlane,
	faPlugCircleBolt as fasPlugCircleBolt,
	faPlus as fasPlus,
	faPresentationScreen as fasPresentationScreen,
	faPuzzlePiece as fasPuzzlePiece,
	faQuoteLeft as fasQuoteLeft,
	faRhombus as fasRhombus,
	faRoad as fasRoad,
	faRuler as fasRuler,
	faRulerTriangle as fasRulerTriangle,
	faScannerGun as fasScannerGun,
	faSeedling as fasSeedling,
	faServer as fasServer,
	faShieldCheck as fasShieldCheck,
	faShieldExclamation as fasShieldExclamation,
	faShieldHalved as fasShieldHalved,
	faShieldHeart as fasShieldHeart,
	faShieldVirus as fasShieldVirus,
	faShip as fasShip,
	faSignsPost as fasSignsPost,
	faSnowflake as fasSnowflake,
	faSolarPanel as fasSolarPanel,
	faSparkles as fasSparkles,
	faSquareBolt as fasSquareBolt,
	faSquareCheck as fasSquareCheck,
	faSquareDashedCirclePlus as fasSquareDashedCirclePlus,
	faSquareParking as fasSquareParking,
	faSquarePlus as fasSquarePlus,
	faStairs as fasStairs,
	faStar as fasStar,
	faStopwatch as fasStopwatch,
	faTable as fasTable,
	faTableList as fasTableList,
	faTimeline as fasTimeline,
	faTrafficCone as fasTrafficCone,
	faTrain as fasTrain,
	faTransformerBolt as fasTransformerBolt,
	faTreeCity as fasTreeCity,
	faTrees as fasTrees,
	faTrianglePersonDigging as fasTrianglePersonDigging,
	faTruck as fasTruck,
	faTruckArrowRight as fasTruckArrowRight,
	faTruckBolt as fasTruckBolt,
	faTruckClock as fasTruckClock,
	faTruckContainer as fasTruckContainer,
	faTruckFast as fasTruckFast,
	faTruckPlane as fasTruckPlane,
	faUser as fasUser,
	faUserHelmetSafety as fasUserHelmetSafety,
	faUsersLine as fasUsersLine,
	faWallet as fasWallet,
	faWarehouse as fasWarehouse,
	faWarehouseFull as fasWarehouseFull,
	faWavePulse as fasWavePulse,
	faWindTurbine as fasWindTurbine,
	faSliders as fasSliders,
} from "@fortawesome/pro-solid-svg-icons";

import {
	faFacebookF as fabFacebookF,
	faGithub as fabGithub,
	faGooglePlusG as fabGooglePlusG,
	faInstagram as fabInstagram,
	faLinkedinIn as fabLinkedinIn,
	faPinterest as fabPinterest,
	faVimeoV as fabVimeoV,
	faWikipediaW as fabWikipediaW,
	faXTwitter as fabXTwitter,
	faYoutube as fabYoutube,
	faWhatsapp as faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import {
	faArrowsFromLine as falArrowsFromLine,
	faLocationDot as falLocationDot,
	faTruck as falTruck,
} from "@fortawesome/pro-light-svg-icons";

// load font-awesome libraries
library.add(
	//brands
	fabFacebookF,
	fabGithub,
	fabGooglePlusG,
	fabInstagram,
	fabLinkedinIn,
	fabPinterest,
	fabVimeoV,
	fabWikipediaW,
	fabXTwitter,
	fabYoutube,
	faWhatsapp,

	//lights
	falArrowsFromLine,
	falLocationDot,
	falTruck,

	//regulars
	far1,
	far2,
	far3,
	far4,
	farArrowsMaximize,
	farBadgeCheck,
	farBars,
	farBicycle,
	farBlockQuestion,
	farBuilding,
	farCalendar,
	farChartLineUp,
	farChevronDown,
	farChevronLeft,
	farChevronRight,
	farChevronUp,
	farCircleExclamation,
	farCircleInfo,
	farCity,
	farEnvelope,
	farEnvelopes,
	farFileCsv,
	farFileDoc,
	farFileExcel,
	farFilePdf,
	farFiles,
	farFileWord,
	farFileZip,
	farGlobe,
	farHandHoldingHeart,
	farHandshake,
	farHeart,
	farKeySkeleton,
	farLandmark,
	farLaptop,
	farListCheck,
	farListOl,
	farLocationDot,
	farLock,
	farPersonChalkboard,
	farPhone,
	farPlane,
	farPlus,
	farRobot,
	farRocketLaunch,
	farSackDollar,
	farShieldHalved,
	farServer,
	farSnowflake,
	farSquare,
	farStar,
	farTemperatureLow,
	farTimes,
	farVectorSquare,
	farVideo,
	farXMark,

	//solids
	fasAddressCard,
	fasArrowDown,
	fasArrowDownToLine,
	fasArrowLeft,
	fasArrowProgress,
	fasArrowRight,
	fasArrowRightLong,
	fasArrowsLeftRightToLine,
	fasArrowsMaximize,
	fasArrowTrendUp,
	fasArrowUpBigSmall,
	fasArrowUpRightDots,
	fasArrowUpRightFromSquare,
	fasBadgeCheck,
	fasBicycle,
	fasBillboard,
	fasBlock,
	fasBlockBrick,
	fasBlog,
	fasBolt,
	fasBookOpen,
	fasBoxesStacked,
	fasBrush,
	fasBuilding,
	fasBuildings,
	fasBuildingShield,
	fasBullhorn,
	fasBullseye,
	fasBullseyeArrow,
	fasBullseyePointer,
	fasCalculatorSimple,
	fasCalendar,
	fasCalendarCheck,
	fasCalendarDay,
	fasCalendarDays,
	fasCalendarPlus,
	fasCameraCctv,
	fasCar,
	fasCaretDown,
	fasCaretLeft,
	fasCaretRight,
	fasCaretUp,
	fasCarSideBolt,
	fasCartFlatbedBoxes,
	fasChairOffice,
	fasChargingStation,
	fasChartMixed,
	fasChartScatter,
	fasChartSimple,
	fasChartSimpleHorizontal,
	fasCheck,
	fasChess,
	fasChessKingPiece,
	fasChevronDown,
	fasChevronLeft,
	fasChevronRight,
	fasChevronUp,
	fasCircleArrowUp,
	fasCircleBolt,
	fasCircleCheck,
	fasCircleInfo,
	fasCircleNodes,
	fasCircleParking,
	fasCircleQuestion,
	fasCircleUser,
	fasCity,
	fasCoin,
	fasCoins,
	fasCompass,
	fasCompassDrafting,
	fasContainerStorage,
	fasConveyorBelt,
	fasConveyorBeltArm,
	fasConveyorBeltBoxes,
	fasCrosshairs,
	fasCrosshairsSimple,
	fasCube,
	fasCubes,
	fasDisplayChartUp,
	fasDownload,
	fasEarthEurope,
	fasEnvelope,
	fasEnvelopes,
	fasEnvelopesBulk,
	fasExpand,
	fasExpandWide,
	fasExternalLink,
	fasFaceSmile,
	fasFileAlt,
	fasFileCertificate,
	fasFileContract,
	fasFileCsv,
	fasFileExcel,
	fasFileImage,
	fasFileLines,
	fasFileLock,
	fasFilePdf,
	fasFilePowerpoint,
	fasFiles,
	fasFileShield,
	fasFileSignature,
	fasFileVideo,
	fasFileWord,
	fasFileZip,
	fasFolders,
	fasForklift,
	fasForward,
	fasForwardFast,
	fasFrame,
	fasGasPump,
	fasGears,
	fasGlobeStand,
	fasHandHoldingBox,
	fasHandHoldingHeart,
	fasHandHoldingSeedling,
	fasHandshake,
	fasHashtag,
	fasHeart,
	fasHeartPulse,
	fasHelmetSafety,
	fasHome,
	fasHouse,
	fasIndustry,
	fasIndustryWindows,
	fasLandmark,
	fasLandmarkFlag,
	fasLanguage,
	fasLayerGroup,
	fasLeaf,
	fasLeafHeart,
	fasLeafOak,
	fasLeafyGreen,
	fasLightbulbOn,
	fasLinesLeaning,
	fasList,
	fasListCheck,
	fasLocationCheck,
	fasLocationDot,
	fasMagnifingGlass,
	fasMap,
	fasMaximize,
	fasMemo,
	fasMemoPad,
	fasMeterBolt,
	fasMicroscope,
	fasMinus,
	fasMoneyBill,
	fasMoneyBillTransfer,
	fasMoneyBillTrendUp,
	fasMoneyBillWave,
	fasMonitorWaveform,
	fasNewspaper,
	fasPalette,
	fasPalletBox,
	fasPalletBoxes,
	fasPaperclip,
	fasPartyHorn,
	fasPenRuler,
	fasPeopleArrows,
	fasPeopleGroup,
	fasPeopleLine,
	fasPeopleRoof,
	fasPersonCarryBox,
	fasPersonDigging,
	fasPersonDolly,
	fasPersonDollyEmpty,
	fasPersonRays,
	fasPersonShelter,
	fasPhone,
	fasPlane,
	fasPlugCircleBolt,
	fasPlus,
	fasPresentationScreen,
	fasPuzzlePiece,
	fasQuoteLeft,
	fasRhombus,
	fasRoad,
	fasRuler,
	fasRulerTriangle,
	fasScannerGun,
	fasSeedling,
	fasServer,
	fasShieldCheck,
	fasShieldExclamation,
	fasShieldHalved,
	fasShieldHeart,
	fasShieldVirus,
	fasShip,
	fasSliders,
	fasSnowflake,
	fasSolarPanel,
	fasSparkles,
	fasSquareBolt,
	fasSquareCheck,
	fasSquareDashedCirclePlus,
	fasSquareParking,
	fasSquarePlus,
	fasStairs,
	fasStar,
	fasStopwatch,
	fasTable,
	fasTableList,
	fasTimeline,
	fasTrafficCone,
	fasTrain,
	fasTransformerBolt,
	fasTreeCity,
	fasTrees,
	fasTrianglePersonDigging,
	fasTruck,
	fasTruckArrowRight,
	fasTruckBolt,
	fasTruckClock,
	fasTruckContainer,
	fasTruckFast,
	fasTruckPlane,
	fasUser,
	fasUserHelmetSafety,
	fasUsersLine,
	fasWallet,
	fasWarehouse,
	fasWarehouseFull,
	fasWavePulse,
	fasWindTurbine,
	fasSliders,
);

// convert i tags to SVG
dom.watch({
	autoReplaceSvgRoot: document,
	observeMutationsRoot: document.body,
});
